import { render, staticRenderFns } from "./deviceTypesForm.vue?vue&type=template&id=7bbc07e6&scoped=true&"
import script from "./deviceTypesForm.vue?vue&type=script&lang=js&"
export * from "./deviceTypesForm.vue?vue&type=script&lang=js&"
import style0 from "./deviceTypesForm.vue?vue&type=style&index=0&id=7bbc07e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc07e6",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QInput,QIcon,QPopupProxy,QColor,QSelect,QBtn});
